(function (global) {
  'use strict';
  const cyrillic = {а:'a',б:'b',в:'v',г:'g',д:'d',ђ:'dj',е:'e',ж:'z',з:'z',и:'i',ј:'j',к:'k',л:'l',љ:'lj',м:'m',н:'n',њ:'nj',о:'o',п:'p',р:'r',с:'s',т:'t',ћ:'c',у:'u',ф:'f',х:'h',ц:'c',ч:'c',џ:'dz',ш:'s'};
  const groups = [
    ['noz','nozevi','nozeve','nozeva','noza','nozem'], ['crevo','creva','crevima','crev'],
    ['masina','masine','masinu','masini','masin'], ['zacin','zacini','zacina','zacinske','zacinski','zacinska'],
    ['omotac','omotaci','omotaca','omotace'], ['mesarski','mesarska','mesarsko','mesarske','mesarskim'],
    ['soljena','soljeno','soljeni','soljenih'], ['prirodna','prirodni','prirodno'], ['vestacka','vestacki','vestacko'],
    ['mlevenje','mljevenje'], ['vakum','vakuum'], ['resetka','resetke','resetki'], ['punilica','punilice'],
    ['ostrac','ostraci','ostraca'], ['rukavica','rukavice'], ['kecelja','kecelje']
  ];
  const aliases = new Map(groups.flatMap(group => group.map(word => [word, group[0]])));
  function normalize(value) {
    return String(value || '').toLowerCase().replace(/[а-яђјљњћџ]/g, c => cyrillic[c] || c).replace(/đ/g,'dj')
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/([a-z])([0-9])/g,'$1 $2').replace(/([0-9])([a-z])/g,'$1 $2')
      .replace(/[^a-z0-9]+/g,' ').trim().replace(/\s+/g,' ');
  }
  const canonical = word => aliases.get(word) || word;
  function tokens(value) {
    const base=normalize(value).split(' ').filter(Boolean),result=base.map(canonical);
    for(let i=0;i<base.length-1;i++)if(/^\d+$/.test(base[i])&&/^\d+$/.test(base[i+1]))result.push(base[i]+base[i+1]);
    return [...new Set(result)];
  }
  function distance(a,b) {
    const rows=Array.from({length:a.length+1},()=>Array(b.length+1).fill(0));
    for(let i=0;i<=a.length;i++)rows[i][0]=i;for(let j=0;j<=b.length;j++)rows[0][j]=j;
    for(let i=1;i<=a.length;i++)for(let j=1;j<=b.length;j++){
      rows[i][j]=Math.min(rows[i-1][j]+1,rows[i][j-1]+1,rows[i-1][j-1]+(a[i-1]===b[j-1]?0:1));
      if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1])rows[i][j]=Math.min(rows[i][j],rows[i-2][j-2]+1);
    }
    return rows[a.length][b.length];
  }
  function matchToken(query,word) {
    if(query===word)return {score:10,fuzzy:false};
    if(/^\d+$/.test(query))return query.length>=3&&word.startsWith(query)?{score:8,fuzzy:false}:null;
    if(word.startsWith(query))return {score:8,fuzzy:false};
    if(query.length>=3&&word.includes(query))return {score:6,fuzzy:false};
    if(query.length<3||/\d/.test(word))return null;
    const limit=query.length>=8?2:1;
    if(Math.abs(query.length-word.length)<=limit&&distance(query,word)<=limit)return {score:4,fuzzy:true};
    if(query.length>=4&&word.length>query.length&&distance(query,word.slice(0,query.length))<=1)return {score:3,fuzzy:true};
    return null;
  }
  function prepare(products) {
    return products.map(p=>({...p,_title:tokens(p.title),_extra:tokens([p.vendor,p.keywords].join(' ')),_phrase:normalize(p.title)}));
  }
  function search(prepared,query) {
    const q=normalize(query).split(' ').filter(Boolean).slice(0,12).map(canonical);
    if(!q.length)return [];
    const results=[],tokenMatches=new Map();
    for(const product of prepared){
      let score=0,fuzzy=false,matched=true;
      for(const term of q){
        let best=null;
        for(const [words,weight]of [[product._title,1],[product._extra,.65]])for(const word of words){
          const key=term+'|'+word;if(!tokenMatches.has(key))tokenMatches.set(key,matchToken(term,word));
          const m=tokenMatches.get(key);if(m&&(!best||m.score*weight>best.score))best={score:m.score*weight,fuzzy:m.fuzzy};
        }
        if(!best){matched=false;break;}score+=best.score;fuzzy ||= best.fuzzy;
      }
      if(matched){if(product._phrase.includes(normalize(query)))score+=5;results.push({product,score,fuzzy});}
    }
    return results.sort((a,b)=>b.score-a.score||Number(b.product.available)-Number(a.product.available)||a.product.title.localeCompare(b.product.title,'sr-Latn'));
  }
  function completions(prepared,query,limit=3) {
    const raw=query.trim().split(/\s+/),last=normalize(raw.pop());if(last.length<2)return [];
    const words=new Map();
    for(const p of prepared)for(const word of p.title.split(/[^\p{L}\p{N}]+/u)){
      const n=normalize(word);if(n.length<3||/^\d+$/.test(n)||n===last)continue;
      const match=matchToken(last,n);if(match&&match.score>=4){const existing=words.get(n);words.set(n,{text:word,count:(existing?.count||0)+1,score:match.score});}
    }
    const result=[];
    for(const candidate of [...words.values()].sort((a,b)=>b.score-a.score||b.count-a.count).slice(0,12)){
      const text=[...raw,candidate.text].join(' ');if(search(prepared,text).length)result.push(text);if(result.length===limit)break;
    }
    return result;
  }
  global.MidecSearchCore={normalize,tokens,prepare,search,completions,matchToken};
})(globalThis);
